import { useMutation, useQueryClient } from '@tanstack/react-query';
import mcpUsuariosService from '../services/mcpUsuariosService';
import { mcpUsuariosKeys } from '../queryKeys';

const useEliminarMcpUsuario = (headquarter) => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id }) => mcpUsuariosService.eliminar({ headquarter, id }),
    onSuccess: () => qc.invalidateQueries({ queryKey: mcpUsuariosKeys.all }),
  });
};

export default useEliminarMcpUsuario;
